module.exports = __webpack_public_path__ + "img/9D282A_38191D_DFC6CD_D6495A-256px.d904cb5c.png";